(function ($) {
	function run($el) {
		var count = Number($el.data("count")) || 0;
		var show = window.innerWidth < 768 ? 4 : 6;
		var needsSlider = count > show;
		var isSliderInitialized = $el.hasClass("slick-initialized");

		if (needsSlider && !isSliderInitialized) {
			$el.slick({
				mobileFirst: true,
				slidesToShow: Math.min(show, count),
				slidesToScroll: 1,
				infinite: true,
				autoplay: true,
				autoplaySpeed: 3000,
				dots: false,
				arrows: false,
			});
		} else if (!needsSlider && isSliderInitialized) {
			$el.slick("unslick");
		} else if (needsSlider && isSliderInitialized) {
			var want = Math.min(show, count);
			var curr = $el.slick("slickGetOption", "slidesToShow");
			if (curr !== want) {
				$el.slick("slickSetOption", "slidesToShow", want, true);
				$el.slick("slickSetOption", "slidesToScroll", 1, true);
			}
		}
	}

	function runAll() {
		$(".block-logo-slider .logo-slider").each(function () {
			run($(this));
		});
	}

	$(function () {
		runAll();
		$(window).on("resize orientationchange", function () {
			clearTimeout(window._logoT);
			window._logoT = setTimeout(runAll, 120);
		});
	});
})(jQuery);
